module.exports = __webpack_public_path__ + "img/lengquebeng.680044e2.png";